const Hero = ({ sendEmail }) => {
  return (
    <div className="h-[100vh] flex flex-col justify-center align-middle items-center tracking-[2px] text-left">
      <div className="" data-aos="fade-up">
        <h2 className="text-lg text-teal-300 font-openSans tracking-[2px] mb-4">
          Hi, I am
        </h2>
        <h1 className="text-6xl text-gray-200 font-bold font-bitter mb-4">
          Mateus Fontoura,
        </h1>
        <h1 className="text-4xl text-gray-400 font-bold font-openSans track mb-4">
          A Code Artist.
        </h1>
        <p className="w-[70%] text-gray-400 font-openSans">
          Bringing beauty and functionality to the digital world one line of
          code at a time.
        </p>

        <div>
          <button
            className="mt-10 border rounded border-teal-400 h-[7vh] w-[20vh] font-bold font-bitter hover:scale-105 duration-500"
            onClick={sendEmail}
          >
            Let's Talk
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
